export { sweetpassLandingPageContentfulFallback } from './sweetpassLandingPageContentfulFallback';
